var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',[_c('div',[_vm._v("Name: "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),_c('div',[_vm._v("Email: "+_vm._s(_vm.user.email))]),_vm._v(" "),(_vm.user.job_role)?_c('div',[_vm._v("Role: "+_vm._s(_vm.user.job_role))]):_vm._e(),_vm._v(" "),_vm._l((_vm.personalVars),function(ref){
var label = ref.label;
var value = ref.value;
return _c('div',{key:label},[_vm._v(_vm._s(label)+": "+_vm._s(value))])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740aa0cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/settings/ViewProfile.vue
// module id = rwXd
// module chunks = 1